"use strict";
// Entity types - manually maintained
// These types are used by the service layer for entity type inference
// Entity schemas are exported from their domain schema files
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypeEnum = exports.CouponTypeEnum = void 0;
// Wallet schemas
const wallet_schemas_1 = require("../schemas/customer/wallet.schemas");
// Points schemas
const points_schemas_1 = require("../schemas/customer/points.schemas");
const enumFromSchemaOptions = (options) => Object.fromEntries(options.map((value) => [value, value]));
// Runtime enum constants for use in components
// Extract enum values from Zod schemas for runtime access
exports.CouponTypeEnum = enumFromSchemaOptions(wallet_schemas_1.CouponTypeSchema.options);
// Runtime enum constant for points transaction types
// Values MUST match the DB CHECK constraint in migration 011
exports.TransactionTypeEnum = enumFromSchemaOptions(points_schemas_1.PointsTransactionTypeSchema.options);
